import {useState} from "react";
import './EventConstructor.scss';
import cn from "classnames";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import axios from "axios";
import Dropzone from './Dropzone';

const availableEventTypes = [
  {tag: 'default', title: 'Без категории'},
  {tag: 'rent', title: 'Прокат картинга'},
  {tag: 'repair', title: 'Тех. работы'},
  {tag: 'academy', title: 'Академия картинга'},
  {tag: 'challenge', title: 'Соревнование'},
];

const EventConstructor = () => {
  const [eventType, setEventType] = useState('default');
  const [image, setImage] = useState('');

  const changeEventType = (e) => {
    setEventType(e.target.value);
  };

  const uploadImage = (files) => {
    const data = new FormData();
    data.append('key', process.env.REACT_APP_IMGBB_API_KEY);
    data.append('action', 'upload');
    data.append('image', files[0]);
    data.append('format', 'json');

    axios.post('https://api.imgbb.com/1/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((res) => {
        if (res.data.success) {
          setImage(res.data.data.url);
        }
      })
  };

  const eventTypeInputs = availableEventTypes.map(({ tag, title }) => (
    <label
      className="xti-event-constructor__event-type-field"
      key={tag}
    >
      <input name="eventType" type="radio" defaultValue={tag} defaultChecked={tag === 'default'} onChange={changeEventType}/>
      <span className={cn('xti-event-constructor__event-type-icon', `xti-event-constructor__event-type-icon--${tag}`)}></span>
      {title}
    </label>
  ));

  const tags = [];

  if (eventType !== 'default') {
    tags.push(`[type=${eventType}]`);
  }

  if (image) {
    tags.push(`[image=${image}]`);
  }


  return (
    <div className="xti-event-constructor">
      <div className="xti-event-constructor__block">
        <div className="xti-event-constructor__block-title">
          1. Выберите необходимые опции
        </div>
        <div className="xti-event-constructor__block-content">
          <div className="xti-event-constructor__field-group">
            <div className="xti-event-constructor__field-group-title">Тип события:</div>
            { eventTypeInputs }
          </div>
          <div className="xti-event-constructor__field-group">
            <div className="xti-event-constructor__field-group-title">Добавьте изображение:</div>
            <Dropzone onDrop={uploadImage} image={image}/>
          </div>
        </div>
      </div>

      <div className="xti-event-constructor__block">
        <div className="xti-event-constructor__block-title">
          2. Вставьте полученный код в начало описания события в Google Calendar
        </div>
        <div className="xti-event-constructor__block-content">
          <div className="xti-event-constructor__result">{tags.map((tag) => <>{tag}<br/></>)}</div>
          <CopyToClipboard text={tags.join('\n')}>
            <span className="xti-event-constructor__copy">Copy</span>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
}

export default EventConstructor;
